// On DOM Ready
jQuery( function( $ ) {

	//# Tooltips

	$('.single-bu_league img[usemap], .page-template-page-guide_field-areas-single img[usemap]').rwdImageMaps();

	if ($(window).width() > 1025) {
		$('.single-bu_league area').each(function() {
			$(this).qtip({
				content: {
					attr: 'title',
					title: function(event, api) {
						return $(this).attr('alt');
					}
				},
				position: {
					my: 'bottom center',
					at: 'center center'
				},
				style: {
					classes: $(this).attr('class')
				},
				show: {
					effect: function() {
						$(this).fadeTo(300, 1);
					}
				},
				hide: {
					effect: function() {
						$(this).fadeOut(300);
					}
				}
			});
		});

		$('.page-template-page-guide_field-areas-single area').each(function() {
			$(this).qtip({
				content: {
					attr: 'title',
					title: function(event, api) {
						return $(this).attr('alt');
					}
				},
 				position: {
					target: 'mouse',
					adjust: { x: 0, y: 0 }
				},
				style: {
					classes: $(this).attr('class')
				},
				show: {
					effect: function() {
						$(this).fadeTo(300, 1);
					}
				},
				hide: {
					effect: function() {
						$(this).fadeOut(300);
					}
				}
			});
		});
	}

	//# League Navigator

	// Setup

	if ( $('#league-menu').length ) {

		var $drillDown = $('#league-menu .drilldown');

		function manageBreadcrumbs() {
			$('#league-menu .breadcrumbs').replaceWith($drillDown.ctDrillDown('getBreadcrumbsFormatted'));
		}

		// Init

		$drillDown.ctDrillDown({
			startName: 'Leagues',
			onOpened: manageBreadcrumbs,
			onClosed: manageBreadcrumbs,
		});

		manageBreadcrumbs();

	} // if league-menu

});
